/**
 * @file
 * Responsive navigation tabs.
 *
 * This also supports collapsible navigable is the 'is-collapsible' class is
 * added to the main element, and a target element is included.
 */
(function($, Drupal, once) {
  function init(i, tab) {
    const $tab = $(tab);
    const $target = $tab.find('[data-tabs-target]');
    const isCollapsible = $tab.hasClass('is-collapsible');

    function openMenu(e) {
      $target.toggleClass('is-open');
    }

    function handleResize(e) {

      // Hide tabs when window is less than 768px and show them when it is greater
      // But do not hide tabs for certain sections
      // var sections = ['meetla'];
      // var segments = window.location.pathname.split( '/' );

      // if ($(window).width() > 768) {
      //   if ($('.dla-region-tabs').is(':hidden')) {
      //     $('.dla-region-tabs').slideDown('fast');
      //   }
      // } else {
      //   if (!$('.dla-region-tabs').is(':hidden') && $.inArray(segments[1], sections) === -1) {
      //     $('.dla-region-tabs').slideUp('fast');
      //   }
      // }

      // Hide tabs when window is less than 768px and show them when it is greater
      if ($(window).width() > 768) {
        if ($('.dla-tabs-container').is(':hidden')) {
          $('.dla-tabs-container').slideDown('fast');
        }
      } else {
        if (!$('.dla-tabs-container').is(':hidden')) {
          $('.dla-tabs-container').slideUp('fast');
        }
      }

      $tab.addClass('is-horizontal');
      const $tabs = $tab.find('[data-tabs-target]');
      const isHorizontal =
        $tabs.outerHeight() <= $tabs.find('li').outerHeight();
      $tab.toggleClass('is-horizontal', isHorizontal);
      if (isCollapsible) {
        $tab.toggleClass('is-collapsed', !isHorizontal);
      }
      if (isHorizontal) {
        $target.removeClass('is-open');
      }
    }

    $tab.addClass('is-horizontal-enabled');

    $tab.on('click.dla_tabs', '[data-tabs-trigger]', openMenu);
    $(window)
      .on('resize.dla_tabs', Drupal.debounce(handleResize, 150))
      .trigger('resize.dla_tabs');
  }

  /**
   * Initialise the tabs JS.
   */
  Drupal.behaviors.dlaTabs = {
    attach(context, settings) {
      const $tabs = $(context).find('[data-tabs]');
      var segments = window.location.pathname.split( '/' );
      if ($tabs.length) {

        // Show tabs nav button if tabs exists, but do not show it for dinela sections for non admin users
        // if ($('.dla-region-tabs').children().length > 0 && ($.inArray(segments[1], ['dinela']) === -1 && !$('body').hasClass('adminimal-admin-toolbar'))) {
        // if ($('.dla-tabs-container').children().length > 0) {
        //   $('.dla-tabs__nav_button').show();
        // } else {
        //   $('.dla-tabs__nav_button').hide();
        // }

        // Hide tabs when window is less than 768px
        // But do not hide tabs for certain sections
        // var sections = ['meetla'];
        // var segments = window.location.pathname.split( '/' );
        // if ($(window).width() <= 768 && $.inArray(segments[1], sections) === -1) {
        //   $('.dla-tabs-container').slideToggle('fast');
        // }

        // Hide tabs when mobile sizes
        // if ($(window).width() <= 768) {
        //   $('.dla-tabs-container').slideToggle('800', "swing", function(){
        //     if ($(this).is(':hidden')) {
        //       // Closed state, show arrow down icon upon completion
        //       $('.dla-tabs__nav_button').find('.dla-arrow-icon-down').show();
        //       $('.dla-tabs__nav_button').find('.dla-arrow-icon-up').hide();
        //     } else {
        //       // Open state, show arrow up icon upon completion
        //       $('.dla-tabs__nav_button').find('.dla-arrow-icon-up').show();
        //       $('.dla-tabs__nav_button').find('.dla-arrow-icon-down').hide();
        //     }
        //   });
        // }

        // Toggle open and close nav styles on click
        // $('.dla-tabs__nav_button').click(function() {
        //   $('.dla-tabs-container').slideToggle('400', "swing", function(){
        //     if ($(this).is(':hidden')) {
        //       // Closed state, show arrow down icon upon completion
        //       $('.dla-tabs__nav_button').find('.dla-arrow-icon-down').show();
        //       $('.dla-tabs__nav_button').find('.dla-arrow-icon-up').hide();
        //     } else {
        //       // Open state, show arrow up icon upon completion
        //       $('.dla-tabs__nav_button').find('.dla-arrow-icon-up').show();
        //       $('.dla-tabs__nav_button').find('.dla-arrow-icon-down').hide();
        //     }
        //   });
        // });

        const notSmartPhone = window.matchMedia('(min-width: 300px)');
        if (notSmartPhone.matches) {
          // $tabs.once('dla-tabs').each(init);
          $(once('dla-tabs', $tabs)).each(init);
        }

      } else {

        // Show tabs nav button if tabs exists, but do not show it for dinela sections for non admin users
        // if ($('.dla-region-tabs').children().length > 0 && ($.inArray(segments[1], ['dinela']) === -1 && !$('body').hasClass('adminimal-admin-toolbar'))) {
        // if ($('.dla-region-tabs').children().length > 0) {
        //   $('.dla-tabs__nav_button').show();
        // } else {
        //   $('.dla-tabs__nav_button').hide();
        // }
      }

    },
  };

  /**
   * Initialise the tabs dropdown JS.
   */
  // Drupal.behaviors.dlaTabsDropdown = {
  //   attach(context, settings) {
  //     const $dropdowns = $(context).find('.dla-tabs__link');
  //     if ($dropdowns.length) {
  //       // Fix bootstrap dropdown parent click
  //       // Detect the second click on the dropdown button/link and follow the link at that point.
  //       // https://stackoverflow.com/questions/48820404/bootstrap-4-keeping-parent-of-dropdown-a-clickable-link
  //       $('.dla-tabs__link').each(function() {
  //         let clicked = 0;
  //         $(this).click(function() {
  //           clicked++;
  //           if (clicked > 1 && $(this).parent().hasClass("show") && $(this).attr('href')) {
  //             location.href = this.href;
  //             clicked = 0;
  //           }
  //         });
  //       });
  //     }
  //   },
  // };

})(jQuery, Drupal, once);
